export class UpdateSkillsEvent {
  constructor(json) {
    this.type = json.Type;
  }
}
